import PropTypes from "prop-types";
import cn from "classnames";
import ReactMarkdown from "react-markdown";
import Truncate from "solar/components/Truncate";
import styles from "solar/components/Markdown.module.scss";

/**
 * @param {bool} styled - Apply basic typography styles for most elements
 * @param {bool} truncate - Should text truncate after first paragraph
 * @param {bool} more - Show text be expandable with a "read more" button
 * @param {node} children - Markdown content
 */

export default function Markdown({
  styled = true,
  truncate = false,
  more = false,
  children,
}) {
  const lineBreakCount = (children?.match(/\n/g) || []).length;
  return (
    <div className={cn(styled.component, styled && styles.styled)}>
      {truncate ? (
        <Truncate markdown more={more && lineBreakCount > 0}>
          <ReactMarkdown linkTarget="_blank">{children}</ReactMarkdown>
        </Truncate>
      ) : (
        <ReactMarkdown>{children}</ReactMarkdown>
      )}
    </div>
  );
}

Markdown.propTypes = {
  children: PropTypes.node.isRequired,
  styled: PropTypes.bool,
  truncate: PropTypes.bool,
  more: PropTypes.bool,
};
